import React, { FC, useContext, useEffect, useReducer, useState } from "react";
import { Button, Card, Col, Container, Row, Table, Breadcrumb, Form } from "react-bootstrap";
import CardHeader from "react-bootstrap/CardHeader";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Confirm from "../../components/messages/Confirm";
import ClipLoader from "react-spinners/ClipLoader";
import { UserType } from "../../types/UserType";
import BusinessSelect from "../../components/form/BusinessSelect";
import { useAuth } from "../../hooks/useAuth";
import { UserListReducer } from "../../reducers/UserReducer";
import { UserModel } from "../../models/UserModel";
import { toast } from "react-toastify";
import { CoupleListReducer, PersonListReducer } from "../../reducers/PersonReducer";
import { CoupleType, PersonType } from "../../types/PersonType";
import CustomSelect from "../../components/form/CustomSelect";
import { OptionType } from "../../types/CommonType";

import IconDelete from "../../assets/icons/delete.svg";
import IconEdit from "../../assets/icons/edit.svg";
import IconPairing from "../../assets/icons/pairing.svg";
import Error from "../../components/messages/Error";
import TranslateTerms from "../../components/TranslateTerms";
import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_COMMON_ALL, LANG_COMMON_AVAILABLE, LANG_COMMON_CHOOSE, LANG_COMMON_CLINIC, LANG_COMMON_DELETE_CONFIRM, LANG_COMMON_DELETE_ERROR, LANG_COMMON_DELETE_SUCCESS, LANG_COMMON_FIND, LANG_COMMON_LOADING, LANG_COMMON_MEDICAL_RECORD_NUMBER, LANG_COMMON_NAME, LANG_COMMON_NEXT, LANG_COMMON_NO_RESULTS, LANG_COMMON_OPTIONS, LANG_COMMON_PATIENTS, LANG_COMMON_PREVIOUS, LANG_COMMON_SEARCH, LANG_ROD_AVAILABILITY } from "../../lang";
import { CoupleModel } from "../../models/CoupleModel";

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import brLocale from '@fullcalendar/core/locales/pt-br';
import EventModal from "./components/modal/EventModal";
import "./calendar.css";
import { EventModel } from "../../models/EventModel";
import { CalendarType, EventType } from "../../types/EventType";
import { AuthContext } from "../../providers/AuthContextProvider";
import CalendarSelect from "../../components/form/CalendarSelect";


interface Props { }
const CalendarPage: FC<Props> = ({ }) => {
    const { searchParam } = useParams();
    const [showAddModal, setShowAddModal] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [coupleToDelete, setCoupleToDelete] = useState<undefined | CoupleType>(undefined);
    const [searchFromBusiness, setSearchFromBusiness] = useState<number | undefined>(undefined);
    const [search, setSearch] = useState<string>((searchParam !== undefined) ? searchParam : "");
    const [pageNumber, setPageNumber] = useState(1);
    const [isLastPage, setIsLastPage] = useState(true);
    const { hasAbility } = useAuth();
    let loadedEvents: EventType[] = [];
    const [selectedEvent, setSelectedEvent] = useState<EventType | null>(null);

    const intl = useIntl();
    const { user } = useContext(AuthContext);
    const [selectedCalendar, setSelectedCalendar] = useState<number | string>("");

    const loadEvents = (calendar_ids: string = "", options: any | undefined = undefined, onDone: (events: EventType[]) => void = ([]) => { }) => {
        if(calendar_ids === "") {
            onDone([]);
            return;
        }

        EventModel().list(calendar_ids, options).then((resp: any) => {
            if (resp !== false) {
                onDone(resp);
            }
        });
    }

    const handleDateClick = (arg: any) => { // bind with an arrow function
        setSelectedEvent({
            id: 0,
            couple_id: 0,
            calendar_id: (selectedCalendar as number) || 0,
            date: moment(arg.date).format('YYYY-MM-DD'),
            time: moment(arg.date).format('HH:mm'),
            duration: 30,
            status: 'scheduled'
        });
        setShowEventModal(true);
    }

    const [showEventModal, setShowEventModal] = useState(false);
    const calendarRef = React.createRef<FullCalendar>();

    useEffect(() => {
        if (calendarRef.current && selectedCalendar !== "") {
            calendarRef.current.getApi().refetchEvents();
        }
    }, [selectedCalendar]);

    useEffect(() => {
        if (user && user.calendars && user.calendars.length > 0) {
            setSelectedCalendar(user.calendars[0].id);
        }
    }, [user]);


    return (
        <>
            {showEventModal && (
                <EventModal
                    show={showEventModal}
                    onHide={() => setShowEventModal(false)}
                    onSave={(event) => {
                        setShowEventModal(false);
                        if (calendarRef.current) {
                            calendarRef.current.getApi().refetchEvents();
                        }
                    }}
                    event={selectedEvent}
                    onDelete={(event_id) => {
                        setShowEventModal(false);
                        setSelectedEvent(null);
                        if (calendarRef.current) {
                            calendarRef.current.getApi().refetchEvents();
                        }
                    }}
                />
            )}

            {/* <Confirm
                message={intl.formatMessage(LANG_COMMON_DELETE_CONFIRM)}
                show={showConfirm}
                onConfirm={async () => {
                    setShowConfirm(false);
                    const id = toast.loading(intl.formatMessage(LANG_COMMON_LOADING));
                    let result = false;
                    if (coupleToDelete !== undefined) {
                        result = await CoupleModel().remove(coupleToDelete?.id);
                    } else {
                        return;
                    }

                    toast.dismiss(id);
                    if (result) {
                        toast.success(intl.formatMessage(LANG_COMMON_DELETE_SUCCESS));
                        loadCouples(searchFromBusiness, { search: search });
                    } else {
                        toast.error(`${intl.formatMessage(LANG_COMMON_DELETE_ERROR)}: ${coupleToDelete?.primary.name}!`, {
                            hideProgressBar: true,
                            autoClose: false
                        });
                    }
                }}
                onHide={() => setShowConfirm(false)}
            /> */}
            <div className="bg-pattern">
                <Container fluid className="mt-4 px-4">
                    <Row>
                        <Col lg={10} style={{ position: 'relative', flexGrow: 1 }}>
                            <div className="calendar-container">
                                <FullCalendar
                                    nowIndicator={true}
                                    businessHours={{
                                        daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
                                        startTime: '08:00', // a start time (10am in this example)
                                        endTime: '18:00', // an end time (6pm in this example)
                                    }}
                                    ref={calendarRef}
                                    scrollTime={moment().format('HH') + ':00:00'}
                                    slotDuration={'00:30:00'}
                                    slotLabelFormat={{
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    }}
                                    allDaySlot={false}
                                    customButtons={{
                                        addEvent: {
                                            text: 'Novo Agendamento',
                                            click: function (args) {
                                                setSelectedEvent({
                                                    id: 0,
                                                    couple_id: 0,
                                                    calendar_id: (selectedCalendar as number) || 0,
                                                    date: "",
                                                    time: "",
                                                    duration: 30,
                                                    status: 'scheduled'
                                                });
                                                setShowEventModal(true);
                                            }
                                        }
                                    }}
                                    locale={brLocale}
                                    plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
                                    initialView="timeGridWeek"
                                    headerToolbar={{
                                        left: 'prev,next today addEvent',
                                        center: 'title',
                                        right: 'timeGridWeek,timeGridDay'
                                    }}
                                    weekends={false}
                                    dateClick={handleDateClick}
                                    eventClick={(info) => {
                                        setSelectedEvent(loadedEvents.find(e => e.id.toString() === info.event.id) || null);
                                        setShowEventModal(true);                                        
                                    }}
                                    stickyHeaderDates={true}
                                    height={"calc(100vh - 140px)"}
                                    expandRows={true}
                                    events={(info, successCallback, failureCallback) => {
                                        loadEvents(selectedCalendar.toString(), {
                                            start: moment(info.start).format('YYYY-MM-DD'),
                                            end: moment(info.end).format('YYYY-MM-DD'),
                                        }, (events) => {
                                            loadedEvents = events;
                                            successCallback(events.map(e => ({
                                                id: e.id.toString(),
                                                title: e.couple ? CoupleModel().formatCoupleName(e.couple) : 'Sem paciente',
                                                start: `${e.date} ${e.time}:00`,
                                                end: `${EventModel().formatEventEndTime(e.date, e.time, e.duration)}`,
                                                backgroundColor: e.type && e.type.color ? e.type.color : '#3788d8',
                                            })));
                                        });
                                    }}
                                />
                            </div>
                        </Col>
                        <Col lg={{ span: 2 }}>
                            <Card>
                                <CardHeader>
                                    <Card.Title><FormattedMessage {...LANG_COMMON_OPTIONS} /></Card.Title>
                                </CardHeader>
                                <Card.Body>
                                    <Form onSubmit={(e) => {
                                        e.preventDefault();
                                        if (calendarRef.current && selectedCalendar !== "") {
                                            calendarRef.current.getApi().refetchEvents();
                                        }
                                    }}>
                                        {hasAbility('BUSINESS_LIST') && (
                                            <>
                                                <label htmlFor="exampleInputEmail1" className="form-label"><FormattedMessage {...LANG_COMMON_CLINIC} /></label>
                                                <BusinessSelect
                                                    onChange={(business_id) => {
                                                        setSearchFromBusiness(business_id);
                                                        //loadCouples(business_id, { search: search });
                                                    }}
                                                />

                                                <br />
                                            </>
                                        )}
                                        <Form.Group className="mb-3">
                                            <Form.Label>Agenda</Form.Label>
                                            <CalendarSelect
                                                name="calendar_id"
                                                onChange={(option: OptionType) => {
                                                    setSelectedCalendar(option.value);                                                    
                                                }}
                                                calendars={user?.calendars || []}
                                                value={selectedCalendar}
                                                isSearchable={false}
                                                key={selectedCalendar} // Force re-render when calendars change
                                            />
                                        </Form.Group>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default CalendarPage;